export default "__VITE_ASSET__11YmwzXr__"